import { render, staticRenderFns } from "./VSearchBar.vue?vue&type=template&id=4f1ce776&scoped=true&"
import script from "./VSearchBar.vue?vue&type=script&lang=js&"
export * from "./VSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./VSearchBar.vue?vue&type=style&index=0&id=4f1ce776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ce776",
  null
  
)

export default component.exports